export const useMakeClass = (...classes) => {
  return classes
    .filter((c) => c)
    .map((c) => c.trim())
    .join(` `);
};

export default { useMakeClass };
